"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProgramHero = _interopRequireDefault(require("../components/ProgramHero/ProgramHero"));

var _KeyPoints = _interopRequireDefault(require("../components/KeyPoints/KeyPoints"));

var _ContactInfo = _interopRequireDefault(require("../components/ContactInfo/ContactInfo"));

var _InfoList = _interopRequireDefault(require("../components/InfoList/InfoList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var DRPETemplate = function DRPETemplateComponent(_ref) {
  var dataClient = _ref.dataClient,
      pageData = _ref.pageData;
  var contact_list = pageData.contact_list,
      contact_section_title = pageData.contact_section_title,
      body = pageData.body,
      linkedContent = pageData.linkedContent;
  var componentMap = {
    key_points: _KeyPoints["default"],
    info_list: _InfoList["default"]
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ProgramHero["default"], {
    dataClient: dataClient,
    pageData: pageData
  }), body.map(function (sliceData, idx) {
    var slice_type = sliceData.slice_type;
    var Component = componentMap[slice_type];
    var key = "".concat(slice_type, "-").concat(idx);
    return Component && /*#__PURE__*/_react["default"].createElement(Component, {
      key: key,
      sliceData: sliceData,
      dataClient: dataClient,
      linkedContent: linkedContent
    });
  }), contact_list && contact_list.length > 0 && /*#__PURE__*/_react["default"].createElement(_ContactInfo["default"], {
    contactList: contact_list,
    sectionTitle: contact_section_title,
    dataClient: dataClient
  }));
};

DRPETemplate.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  pageData: _propTypes["default"].shape({}).isRequired
};
var _default = DRPETemplate;
exports["default"] = _default;